import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseDetailPageComponent } from '../../../../../components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from '../../../../../models/base-detail-page.config';
import { QualityManagementService } from '../../../../../services/quality-management.service';
import { RouteService } from '../../../../../services/route.service';
import { CommonService } from '../../../../../services/common.service';
import { MainLayoutService } from '../../../../../services/main-layout.service';
import { AccessControlService } from '../../../../../services/access-control.service';
import { CompanyDocumentGroup } from '../../../../../models/entities/company-document';

@Component({
  selector: 'app-quality-document-group-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './quality-document-group-detail-page.component.html',
  styleUrl: './quality-document-group-detail-page.component.scss'
})
export class QualityDocumentGroupDetailPageComponent implements OnInit, OnDestroy {

  baseDetailPageConfig!: BaseDetailPageConfig;
  companyDocumentGroup?: CompanyDocumentGroup;

  private destroy$ = new Subject<void>();

  constructor(
    private qualityManagementService: QualityManagementService,
    private routeService: RouteService,
    private commonService: CommonService,
    private mainLayoutService: MainLayoutService,
    private accessControlService: AccessControlService
  ) { }

  ngOnInit(): void {
    this.baseDetailPageConfig = {
      pageTitle: 'Quality Document Group',
      cardTitle: 'Quality Document Group Detail',
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => item?.code ?? '-'
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => item?.name ?? '-'
          },
          {
            attribute: 'createTime',
            label: 'Create Time',
            value: (item: any) => this.formatDate(item?.createTime)
          }
        ]
      },
      apiDetailService: (companyDocumentGroupId: number) =>
        this.qualityManagementService.detailCompanyDocumentGroup(companyDocumentGroupId),
      routeParamName: 'companyDocumentGroupId',
      responseModelName: 'companyDocumentGroup'
    };

    this.mainLayoutService.activeProfile$
      .pipe(takeUntil(this.destroy$))
      .subscribe(profileCode => {
        const canModify = this.accessControlService.hasFeatureActionAccess(
          profileCode,
          'QUALITY_MANAGEMENT_SETTINGS_DOCUMENT_GROUPS',
          'modify'
        );

        this.baseDetailPageConfig.editItemButton = canModify
          ? {
              type: 'success',
              title: 'Edit Group',
              onClick: () => this.routeService.qualityDocumentGroupUpdate(
                Number(this.companyDocumentGroup?.companyDocumentGroupId)
              )
            }
          : undefined;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onLoadedDetail(data: CompanyDocumentGroup): void {
    this.companyDocumentGroup = data;
  }

  private formatDate(value?: string | null): string {
    if (!value) {
      return '-';
    }

    const date = new Date(value);
    return isNaN(date.getTime()) ? '-' : this.commonService.formatDate(date);
  }
}
